import LazyLoaderErrorBoundary from '@components/Errors/LazyLoaderErrorBoundary';
export default async function Loadable() {
    const { SchedulingWrapper } = await import('./SchedulingWrapper');
    return {
        Component: SchedulingWrapper,
        ErrorBoundary: LazyLoaderErrorBoundary,
    };
}
